'use strict';

var tslib_es6 = require('./tslib.es6-13d783d6.js');
var styled = require('styled-components');
var Animation_index = require('./Animation/index.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _a;
(function (SpinnerScheme) {
    SpinnerScheme["dark"] = "dark";
    SpinnerScheme["light"] = "light";
})(exports.SpinnerScheme || (exports.SpinnerScheme = {}));
var noFill = 'transparent';
var schemePallettes = (_a = {},
    _a[exports.SpinnerScheme.dark] = [
        ['#fff', '#ddd'],
        ['#ddd', '#bbb'],
        ['#bbb', '#999'],
        ['#999', '#777'],
        ['#777', '#666'],
        ['#666', '#666459'],
    ],
    _a[exports.SpinnerScheme.light] = [
        [noFill, noFill],
        [noFill, noFill],
        [noFill, noFill],
        ['#fff', '#fff'],
        ['#fff', '#fff'],
        ['#fff', '#fff'],
    ],
    _a);
var SvgSpinner = function (props) {
    var _a = props.scheme, scheme = _a === void 0 ? exports.SpinnerScheme.dark : _a;
    var pallette = schemePallettes[scheme];
    return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "100", height: "100", viewBox: "0 0 300 300" }, props),
        React__default['default'].createElement("linearGradient", { id: "a", x2: "1", y2: "1" },
            React__default['default'].createElement("stop", { offset: "20%", stopColor: pallette[0][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[0][1] })),
        React__default['default'].createElement("linearGradient", { id: "b", x1: ".5", x2: ".5", y2: "1" },
            React__default['default'].createElement("stop", { offset: "0%", stopColor: pallette[1][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[1][1] })),
        React__default['default'].createElement("linearGradient", { id: "c", x1: "1", x2: "0", y2: "1" },
            React__default['default'].createElement("stop", { offset: "0%", stopColor: pallette[2][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[2][1] })),
        React__default['default'].createElement("linearGradient", { id: "d", x1: "1", y1: "1", x2: "0" },
            React__default['default'].createElement("stop", { offset: "0%", stopColor: pallette[3][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[3][1] })),
        React__default['default'].createElement("linearGradient", { id: "e", x1: ".5", y1: "1", x2: ".5" },
            React__default['default'].createElement("stop", { offset: "0%", stopColor: pallette[4][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[4][1] })),
        React__default['default'].createElement("linearGradient", { id: "f", y1: "1", x2: "1" },
            React__default['default'].createElement("stop", { offset: "0%", stopColor: pallette[5][0] }),
            React__default['default'].createElement("stop", { offset: "100%", stopColor: pallette[5][1] })),
        React__default['default'].createElement("path", { d: "M150 30a120 120 0 0 1 103.923 60.2", fill: "none", stroke: "url(#a)", strokeWidth: "16" }),
        React__default['default'].createElement("path", { d: "M253.923 90a120 120 0 0 1 0 120", fill: "none", stroke: "url(#b)", strokeWidth: "16" }),
        React__default['default'].createElement("path", { d: "M254.523 209A120 120 0 0 1 149.6 270", fill: "none", stroke: "url(#c)", strokeWidth: "16" }),
        React__default['default'].createElement("path", { d: "M150 270a120 120 0 0 1-103.923-60", fill: "none", stroke: "url(#d)", strokeWidth: "16" }),
        React__default['default'].createElement("path", { d: "M46.777 211a120 120 0 0 1-1.3-120", fill: "none", stroke: "url(#e)", strokeWidth: "16" }),
        React__default['default'].createElement("path", { d: "M44.948 92A120 120 0 0 1 149.87 30", fill: "none", stroke: "url(#f)", strokeWidth: "16" })));
};

var RotatingSpinner = styled__default['default'](SvgSpinner).withConfig({ displayName: "ww-uikit_RotatingSpinner_l0c9i4uf", componentId: "sc-fxjl7s" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    animation: ", " 0.6s linear infinite;\n"], ["\n    animation: ", " 0.6s linear infinite;\n"])), Animation_index.animationRotate);
var FullPageSpinner = styled__default['default'](RotatingSpinner).withConfig({ displayName: "ww-uikit_FullPageSpinner_l0c9i4uf", componentId: "sc-1csz1i8" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    height: 58px;\n    width: 58px;\n    position: fixed;\n    left: calc(50vw - 29px);\n    top: calc(50vh - 29px);\n"], ["\n    height: 58px;\n    width: 58px;\n    position: fixed;\n    left: calc(50vw - 29px);\n    top: calc(50vh - 29px);\n"])));
var InlineSpinner = styled__default['default'](RotatingSpinner).withConfig({ displayName: "ww-uikit_InlineSpinner_l0c9i4uf", componentId: "sc-oscmh5" })(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    left: calc(50% - 20px);\n    top: calc(50% - 20px);\n"], ["\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    left: calc(50% - 20px);\n    top: calc(50% - 20px);\n"])));
var templateObject_1, templateObject_2, templateObject_3;

exports.FullPageSpinner = FullPageSpinner;
exports.InlineSpinner = InlineSpinner;
exports.RotatingSpinner = RotatingSpinner;
exports.SvgSpinner = SvgSpinner;
//# sourceMappingURL=RotatingSpinners-108d73e8.js.map
